import { ChangeDetectionStrategy, Component, OnInit, Input, ViewChild, ElementRef, ContentChildren, QueryList, Output, EventEmitter, AfterContentInit, AfterViewChecked, Inject, forwardRef, OnDestroy, EmbeddedViewRef, TemplateRef, ViewContainerRef, signal } from '@angular/core';
import { BlockableUI, PrimeTemplate } from 'primeng/api';
import { zAppDevComponentStatus } from '../component-status';
import { zAppDevTabViewComponent } from './tabView.component';
import * as ThemeOptions from '../../theme/interfaces/options';
import { CF_COMPONENT } from '../../rule-engine/directives/condition-formatting.directive';
import { zAppDevBaseComponent } from '../BaseComponent/base.component';
import { transformStyleToObject } from '@framework/common';
import { CommonModule } from '@angular/common';

let idx: number = 0;

@Component({
  selector: 'zapp-tabPanel',
  templateUrl: './tabPanel.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule],
  providers: [{ provide: CF_COMPONENT, useExisting: ZAppDevTabPanel }],
})
export class ZAppDevTabPanel extends zAppDevBaseComponent {

  @Input() name: string;

  @Input() closable: boolean;

  @Input() headerItemClass: string;

  @Input() headerItemLinkClass: string;

  @Input() cache: boolean = true;

  @Input() tooltip: any;

  @Input() tooltipPosition: string = 'top';

  @Input() tooltipPositionStyle: string = 'absolute';

  @Input() tooltipStyleClass: string;

  @Input() contentTemplate: TemplateRef<any>;

  @Input() headerTemplate: TemplateRef<any>;

  @Output() onSelect: EventEmitter<any> = new EventEmitter();

  //@ContentChildren(PrimeTemplate) templates: QueryList<any>;

  closed = signal<boolean>(false);

  view: EmbeddedViewRef<any>;

  _selected = signal<boolean>(false);

  _header = signal<string>(undefined);

  _leftIcon = signal<string>(undefined);

  _rightIcon = signal<string>(undefined);

  loaded = signal<boolean>(false);

  id: string = `p-tabpanel-${idx++}`;

  tabView: zAppDevTabViewComponent;

  constructor(@Inject(forwardRef(() => zAppDevTabViewComponent)) tabView, public viewContainer: ViewContainerRef, protected elementRef: ElementRef) {
    super(elementRef);
    this.tabView = tabView as zAppDevTabViewComponent;
  }

  //ngAfterContentInit() {
  //  this.templates.forEach((item) => {
  //    switch (item.getType()) {
  //      case 'header':
  //        this.headerTemplate = item.template;
  //        break;

  //      case 'content':
  //        this.contentTemplate = item.template;
  //        break;

  //      default:
  //        this.contentTemplate = item.template;
  //        break;
  //    }
  //  });
  //}

  @Input() get selected(): boolean {
    return this._selected();
  }

  set selected(val: boolean) {
    if (this._selected() != true && val == true) {
      this.onSelect.emit({});
    }

    this._selected.set(val);

    if (val)
      this.loaded.set(true);
  }

  //@Input() get disabled(): boolean {
  //  return this._disabled;
  //};

  //set disabled(disabled: boolean) {
  //  this._disabled = disabled;
  //  this.tabView.cd.markForCheck();
  //}

  @Input() get header(): string {
    return this._header();
  }

  set header(header: string) {
    this._header.set(header);
  }

  @Input() get leftIcon(): string {
    return this._leftIcon();
  }

  set leftIcon(leftIcon: string) {
    this._leftIcon.set(leftIcon);
  }

  @Input() get rightIcon(): string {
    return this._rightIcon();
  }

  set rightIcon(rightIcon: string) {
    this._rightIcon.set(rightIcon);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.view = null;
  }
}
